import { render } from "./AnimatedCounter.vue?vue&type=template&id=95e7a4f6&ts=true"
import script from "./AnimatedCounter.vue?vue&type=script&lang=ts"
export * from "./AnimatedCounter.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__